export function useEndpoints() {
	// Endpoints are defined in nuxt-base/app.config.ts and inherited by all projects via Nuxt layers
	const _endpoints = useAppConfig().hapiEndpoints;

	const get = endpoint => {
		return endpoint ? _endpoints?.[endpoint] : _endpoints;
	};

	return {endpoints: _endpoints, get};
}
